export default __webpack_public_path__ + "static/media/studio4.c4d03781.jpg";